import { createFileRoute, Link } from '@tanstack/react-router'
import { Network, Wifi, SmilePlus, MonitorSmartphone } from 'lucide-react'
import Banner from '@/components/banner'
import FeaturedServicesCard from '@/components/card/featuredServicesCard'

export const Route = createFileRoute('/')({
  component: App,
})

const cardData = {
  title: `${WHOLESALERNAME} nbn™`,
  description:
    'High speed nbn™ plans with everything you need to keep your home and business connected.',
  icon: (
    <Network className="text-icon-primary mb-4" size={120} strokeWidth={1.5} />
  ),
  linkTo: '/nbn',
  linkTitle: 'Go to nbn™ plans',
}

const cardData2 = [
  {
    title: 'Designed to be easy',
    description:
      'Simple plans tailored for home and small business. Sign up online in minutes.',
    icon: (
      <MonitorSmartphone
        className="text-icon-primary mb-4"
        size={120}
        strokeWidth={1.5}
      />
    ),
  },
  {
    title: 'High speed network',
    description:
      'Keep connected to what matters most with our fast, reliable network.',
    icon: (
      <Wifi className="text-icon-primary mb-4" size={120} strokeWidth={1.5} />
    ),
  },
  {
    title: '24/7 technical support',
    description:
      'We’re available 24 hours a day, 7 days a week in case something goes wrong.',
    icon: (
      <SmilePlus
        className="text-icon-primary mb-4"
        size={120}
        strokeWidth={1.5}
      />
    ),
  },
]

function App() {
  return (
    <>
      <Banner
        backgroundUrl="/img/banner.jpg"
        containerStyle="banner-gradient min-h-[450px] lg:min-h-[520px]"
      >
        <div className="relative px-4 z-10 h-full w-full max-w-[1380px] mx-auto my-auto">
          <p className="text-4xl font-bold text-white max-w-[440px] mb-6">
            Unlimited nbn™ plans starting from $60
          </p>
          <Link to="/sign-up" className="btn btn-secondary-darken">
            Start Here
          </Link>
        </div>
      </Banner>

      <div className="content-container bg-content-primary">
        <div className="breakpoint-container flex flex-col">
          <h1 className="content-title self-center">
            What are you looking for today?
          </h1>

          <div className="card-row-container flex-wrap lg:flex-nowrap">
            <FeaturedServicesCard
              containerStyle="md:max-w-[48%]"
              cardData={cardData}
            />
          </div>
        </div>
      </div>

      <div className="content-container">
        <div className="breakpoint-container flex flex-col">
          <h1 className="content-title self-center">Why {WHOLESALERNAME}?</h1>
          <div className="card-row-container flex-wrap lg:flex-nowrap">
            {cardData2.map((data, index) => (
              <FeaturedServicesCard
                key={index}
                containerStyle="md:max-w-[48%] lg:max-w-none"
                cardData={data}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
